<template>
  <div class="columns">
    <div class="column">
      <div class="field">
        <label class="label">Geometry Selection</label>
        <div class="control my-half-space">
          <div class="select">
            <select v-model="optionGeometry" v-on:change="onGeometry" id="step1-geometry-selection">
              <option v-for="(opt, i) in geometries" :value="i" :key="i">{{ opt }}</option>
            </select>
          </div>
        </div>
        <button class="button is-primary breatheTop" v-on:click="toggleModalInfo">
          <font-awesome-icon icon="info-circle" /><span style="padding-left: 0.25em">Show Geometry</span>
        </button>
      </div>
    </div>
    <div class="column">
      <div v-if="optionGeometry === 0">
        <div class="field">
          <label class="label">Stent Options</label>
          <div class="control">
            <label class="radio my-margin-top">
              <input
                type="radio"
                name="stent"
                value="single"
                v-model="optionStent"
                v-on:change="onStent"
                id="step1-stent-options-one"
              />
              Single Stent
            </label>
            <br />
            <label class="radio my-margin-top">
              <input
                type="radio"
                name="stent"
                value="double"
                v-model="optionStent"
                v-on:change="onStent"
                id="step1-stent-options-two"
              />
              Double Stent
            </label>
          </div>
        </div>
      </div>
      <div v-else-if="optionGeometry === 1 || optionGeometry === 2">
        <div class="field">
          <label class="label">Insulation</label>
          <div class="control">
            <label class="checkbox my-margin-top">
              <input
                type="checkbox"
                v-model="optionInsulation"
                v-on:change="onInsulation"
                id="step1-include-insulation-rod"
              />
              Include Insulation
            </label>
          </div>
        </div>
      </div>
      <div v-else-if="optionGeometry === 2">{{geometries[optionGeometry]}}</div>
      <div v-else>No valid geometry selected.</div>
    </div>
    <div class="column">
      <div v-if="optionGeometry === 0">
        <div class="field">
          <label class="label">Insulation</label>
          <div class="control">
            <label class="checkbox my-margin-top">
              <input
                type="checkbox"
                v-model="optionInsulationOne"
                v-on:change="onInsulation"
                id="step1-include-insulation-one"
              />
              Include for Stent 1
            </label>
          </div>
          <div v-if="optionStent === 'double'" class="control">
            <label class="checkbox my-margin-top">
              <input
                type="checkbox"
                v-model="optionInsulationTwo"
                v-on:change="onInsulation"
                id="step1-include-insulation-two"
              />
              Include for Stent 2
            </label>
          </div>
        </div>
      </div>
      <div v-else-if="optionGeometry === 1 || optionGeometry === 2">
        <div v-if="optionInsulation === true">
          <div class="field">
            <label class="label">Rod Tip</label>
            <div class="control">
              <label class="radio my-margin-top">
                <input
                  type="radio"
                  name="rod"
                  value="0"
                  v-model="optionTip"
                  v-on:change="onTip"
                  id="step1-rod-tip-none"
                />
                None
              </label>
              <br />
              <label class="radio my-margin-top">
                <input
                  type="radio"
                  name="rod"
                  value="1"
                  v-model="optionTip"
                  v-on:change="onTip"
                  id="step1-rod-tip-one"
                />
                1-Tip
              </label>
              <br />
              <label class="radio my-margin-top">
                <input
                  type="radio"
                  name="rod"
                  value="2"
                  v-model="optionTip"
                  v-on:change="onTip"
                  id="step1-rod-tip-two"
                />
                2-Tip
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal: Information about selected geometry configuration -->
    <div class="modal" v-bind:class="{'is-active': activeModalInfo}">
      <div class="modal-background" v-on:click="toggleModalInfo"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Geometry Information</p>
          <button class="delete" aria-label="close" v-on:click="toggleModalInfo"></button>
        </header>
        <section class="modal-card-body">
          <div v-if="optionGeometry === 0">
            <div v-if="optionStent === 'single'">
              <img src="../../assets/stent1_no.png" v-if="optionInsulationOne === false" />
              <img src="../../assets/stent1_insulated.png" v-if="optionInsulationOne === true" />
            </div>
            <div v-if="optionStent === 'double'">
              <img
                src="../../assets/stent2_no.png"
                v-if="optionInsulationOne === false && optionInsulationTwo === false"
              />
              <img
                src="../../assets/stent2_first.png"
                v-if="optionInsulationOne === true && optionInsulationTwo === false"
              />
              <img
                src="../../assets/stent2_second.png"
                v-if="optionInsulationOne === false && optionInsulationTwo === true"
              />
              <img
                src="../../assets/stent2_both.png"
                v-if="optionInsulationOne === true  && optionInsulationTwo === true"
              />
            </div>
          </div>
          <div v-if="optionGeometry === 1">
            <img src="../../assets/Rod_bare.png" v-if="optionInsulation === false" />
            <img
              src="../../assets/Rod_insulated.png"
              v-if="optionInsulation === true && optionTip == 0"
            />
            <img
              src="../../assets/Rod_1Tip.png"
              v-if="optionInsulation === true  && optionTip == 1"
            />
            <img
              src="../../assets/Rod_2Tip.png"
              v-if="optionInsulation === true  && optionTip == 2"
            />
          </div>
          <p class="my-half-space">Based on your selected options.</p>
        </section>
        <footer class="modal-card-foot">
          <button class="button" v-on:click="toggleModalInfo">Close</button>
        </footer>
      </div>
      <button class="modal-close is-large" aria-label="close" v-on:click="toggleModalInfo"></button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      optionGeometry: 0,
      optionStent: 'single',
      optionInsulation: false,
      optionInsulationOne: false,
      optionInsulationTwo: false,
      optionTip: 0,
      geometries: ['Simplified Stent', 'Simplified Rod'], // 'Simplified Helix Rod'
      activeModalInfo: false,
    };
  },
  methods: {
    onGeometry() {
      this.optionInsulation = false;
      this.optionInsulationOne = false;
      this.optionInsulationTwo = false;
      this.$emit('onInsulation', 0);
      this.$emit('onGeometry', this.optionGeometry);
    },
    onStent() {
      this.optionInsulation = false;
      this.optionInsulationOne = false;
      this.optionInsulationTwo = false;
      this.$emit('onInsulation', 0);
      this.$emit('onStent', this.optionStent);
    },
    onInsulation() {
      let insulations = 0;
      if (this.optionGeometry === 0) {
        if (this.optionInsulationOne) {
          insulations = 1; // only insulation for first stent
        }
        if (this.optionInsulationTwo) {
          insulations += 2; // 2: only second stent, 3: for both stents
        }
      } else if (this.optionInsulation) {
        insulations = 1;
      }
      this.$emit('onInsulation', insulations);
    },
    onTip() {
      this.$emit('onTip', this.optionTip);
    },
    toggleModalInfo() {
      this.activeModalInfo = !this.activeModalInfo;
    },
  },
  props: {},
};
</script>

<style scoped>
.my-half-space {
  padding-top: 0.5em;
}

label.my-margin-top {
  margin-top: 0.75em;
}
button.breatheTop {
  margin-top: 0.5em;
}
img {
  height: 40em;
}
</style>
